const THEMES = {
  Aurora: {
    icon: "mdi-shimmer",
    color: "#059669", bg: "#D1FAE5", text: "#065F46",
    textDark: "#064E3B", textMid: "#047857",
  },
  "The Moon": {
    icon: "mdi-moon-waning-crescent",
    color: "#475569", bg: "#F1F5F9", text: "#334155",
    textDark: "#1E293B", textMid: "#475569",
  },
  "The Sun": {
    icon: "mdi-white-balance-sunny",
    color: "#D97706", bg: "#FEF3C7", text: "#92400E",
    textDark: "#78350F", textMid: "#B45309",
  },
  "The Star": {
    icon: "mdi-star-shooting",
    color: "#2563EB", bg: "#DBEAFE", text: "#1E40AF",
    textDark: "#1E3A8A", textMid: "#1D4ED8",
  },
  "The Galaxy": {
    icon: "mdi-orbit",
    color: "#7C3AED", bg: "#EDE9FE", text: "#5B21B6",
    textDark: "#4C1D95", textMid: "#6D28D9",
  },
  Supercluster: {
    icon: "mdi-crown",
    color: "#EA580C", bg: "#FEF2E8", text: "#9A3412",
    textDark: "#7C2D12", textMid: "#C2410C",
  },
};

const DEFAULT = {
  icon: "mdi-star-circle-outline",
  color: "#9CA3AF", bg: "#F3F4F6", text: "#6B7280",
  textDark: "#374151", textMid: "#6B7280",
};

export function packTheme(name) {
  return THEMES[name] || DEFAULT;
}
